export default {
  blank: { name: 'required' },
  present: { name: 'empty' },
  taken: { name: 'taken', params: ({ value }) => [value] },
  inclusion: { name: 'included', params: ({ value }) => [value] },

  // too_short: { name: 'required', params(options) { return [options.count]; } },
  // after: { name: 'after' },
  // alpha: { name: 'alpha' },
  // alpha_dash: { name: 'alpha_dash' },
  // alpha_num: { name: 'alpha_num' },
  // alpha_spaces: { name: 'alpha_spaces' },
  // before: { name: 'required' },
  // between: { name: 'required' },
  // confirmed: { name: 'required' },
  // credit_card: { name: 'required' },
  // date_between: { name: 'required' },
  // date_format: { name: 'required' },
  // decimal: { name: 'required' },
  // digits: { name: 'required' },
  // dimensions: { name: 'required' },
  // email: { name: 'required' },
  // ext: { name: 'required' },
  // image: { name: 'required' },
  // in: { name: 'required' },
  // ip: { name: 'required' },
  // max: { name: 'required' },
  // max_value: { name: 'required' },
  // mimes: { name: 'required' },
  // min: { name: 'required' },
  // min_value: { name: 'required' },
  // not_in: { name: 'required' },
  // numeric: { name: 'required' },
  // regex: { name: 'required' },
  // required: { name: 'required' },
  // size: { name: 'required' },
  // url: { name: 'required' },
};
